import {not_found} from './not_found';
import {wave_curve} from './wave_curve';
import {pattern_triangle} from './pattern_triangle';
import {pattern_boil} from './pattern_boil';
import {parallax_dragon} from './parallax_dragon';
import {wave_triangle} from './wave_triangle';
import {cycle_city_lights} from './cycle_city_lights';
import {pattern_cubes} from './pattern_cubes';
import {pattern_capsule} from './pattern_capsule';
import {pattern_diamond} from './pattern_diamond';
import {wave_steps} from './wave_steps';
import {wave_big} from './wave_big';
import {wave_blob} from './wave_blob';
import {wave_multi} from './wave_multi';
import {pattern_cloud} from './pattern_cloud';
import {parallax_landscape} from './parallax_landscape';
import {pattern_bubbles} from './pattern_bubbles';
import {special_wind_turbines} from './special_wind_turbines';
import {special_rotating_gears} from './special_rotating_gears';
import {parallax_boat} from './parallax_boat';
import {parallax_forest} from './parallax_forest';
import {cycle_delivery_truck} from './cycle_delivery_truck';
import {pattern_box} from './pattern_box';
import {special_fire_pit} from './special_fire_pit';
import {cycle_tree_leaves} from './cycle_tree_leaves';
import {cycle_swimming_fish} from './cycle_swimming_fish';
import {cycle_sun_and_moon} from './cycle_sun_and_moon';
import {cycle_hourglass} from './cycle_hourglass';
import {pattern_fold} from './pattern_fold';
import {special_rotating_circles} from './special_rotating_circles';
import {parallax_airplane} from './parallax_airplane';

import {wave_bow} from './wave_bow';
import {wave_layers} from './wave_layers';
import {wave_shoreline} from './wave_shoreline';
import {special_polygons} from './special_polygons';
import {special_splash} from './special_splash';

let options = {
  not_found,
  wave_curve,
  pattern_triangle,
  pattern_boil,
  parallax_dragon,
  wave_triangle,
  cycle_city_lights,
  pattern_cubes,
  pattern_capsule,
  pattern_diamond,
  wave_steps,
  wave_big,
  wave_blob,
  wave_multi,
  pattern_cloud,
  parallax_landscape,
  pattern_bubbles,
  special_wind_turbines,
  special_rotating_gears,
  parallax_boat,
  parallax_forest,
  cycle_delivery_truck,
  pattern_box,
  special_fire_pit,
  cycle_tree_leaves,
  cycle_swimming_fish,
  cycle_sun_and_moon,
  cycle_hourglass,
  pattern_fold,
  special_rotating_circles,
  parallax_airplane,
  wave_bow,
  wave_layers,
  wave_shoreline,
  special_polygons,
  special_splash,
}
export function getVariation(name) {
  if(options[name] == undefined)options[name] = not_found;
  return function({compId,shapeHeight,animationSpeed,flipAnimation}) {
    return options[name]({compId,shapeHeight,animationSpeed,flipAnimation})
  }
}
export function processShapeVariation(shapeVariation) {
    const validOptions = [
      'wave_big',
      'pattern_box',
      'special_404',
      'not_found'
    ];
    let makeReq = true;
    for (let i = 0; i < validOptions.length; i++) {
      if (shapeVariation.includes(validOptions[i])) {
        makeReq = false;
      }
    }
    if (makeReq) {
      shapeVariation = "wave_big";
    }
  return shapeVariation;
}
export function supportsBottom(shapeVariation) {
    let showLocation = false;
		if(shapeVariation.includes("wave_")) showLocation = true;
		else if(shapeVariation.includes("pattern_") && (!shapeVariation.includes("pattern_boil") && !shapeVariation.includes("pattern_cubes") && !shapeVariation.includes("pattern_fold"))) showLocation = true;
		else if(shapeVariation.includes("special_polygon")) showLocation = true;
    return showLocation;
}